import React, { Component, Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import {
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Row,
  Col,
} from "reactstrap";
import PageTitle from "../../../Layout/AppMain/PageTitle";
import DashboardTiles from "./DashboardTiles";
import Telco from "./Telco";
import Enterprise from "./Enterprise";
import TelcoCustomer from "./TelcoCustomer";
import EnterpriseNew from "./EnterpriseNew";

class ExternalDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentActiveTab: "2",
    };
  }

  toggle = (tab) => {
    if (this.state.currentActiveTab !== tab) {
      this.setState({
        currentActiveTab: tab,
      });
    }
  };

  render() {
    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          {/* <PageTitle
                        heading={"Single Pane Of Glass"}
                        doActions={this.openAddHPModel}
                        downloadReport=""
                        showButton={false}
                        downloadData={[]}
                        headers=""
                        fileName=""
                    /> */}

          <div>
            <Card className="mb-3" style={{ borderRadius: 0 }}>
              <CardBody className="p-0">
                <div
                  className="panel with-nav-tabs panel-primary"
                  style={{ borderColor: "#ddd" }}
                >
                  <Nav tabs={true}>
                    {/* <NavItem>
                      <NavLink
                        href="javascript:void(0);"
                        className={
                          this.state.currentActiveTab === "1"
                            ? "active nav-link"
                            : "nav-link"
                        }
                        style={{
                          fontWeight:
                            this.state.currentActiveTab === "1" ? "bold" : "",
                        }}
                        onClick={() => {
                          this.toggle("1");
                        }}
                      >
                        Telco
                      </NavLink>
                    </NavItem> */}
                    <NavItem>
                      <NavLink
                        href="javascript:void(0);"
                        className={
                          this.state.currentActiveTab === "2"
                            ? "active nav-link"
                            : "nav-link"
                        }
                        style={{
                          fontWeight:
                            this.state.currentActiveTab === "2" ? "bold" : "",
                        }}
                        onClick={() => {
                          this.toggle("2");
                        }}
                      >
                        Enterprise
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="javascript:void(0);"
                        className={
                          this.state.currentActiveTab === "3"
                            ? "active nav-link"
                            : "nav-link"
                        }
                        style={{
                          fontWeight:
                            this.state.currentActiveTab === "3" ? "bold" : "",
                        }}
                        onClick={() => {
                          this.toggle("3");
                        }}
                      >
                        TelcoCustomer
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>

                <TabContent activeTab={this.state.currentActiveTab}>
                  <TabPane tabId="1">
                    <Telco />
                  </TabPane>

                  <TabPane tabId="2">
                    <EnterpriseNew />
                  </TabPane>

                  <TabPane tabId="3">
                    <TelcoCustomer />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </div>

          {/* <div className="mb-3">
                        <Row>
                            <Col md="12">
                                <DashboardTiles />
                            </Col>
                        </Row>
                    </div> */}
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }
}

export default ExternalDashboard;
